import type { ReactNode } from 'react'
import styles from './Table.module.css'

export function TableWrap({ children }: { children: ReactNode }) {
  return (
    <div className={styles.wrap}>
      <div className={styles.scroll}>{children}</div>
    </div>
  )
}
